<template>
  <q-card flat class="q-pa-md">
    <div :class="$q.dark.mode ? '' : 'text-primary '">
      <span class="text-bd text-bold">Mean Reversal Signals</span>

      <p class="text-caption text-bold">
        As of : {{ $store.state.market.asOf }}
      </p>
    </div>
    <PackageAuth packageAuthorization="Platinum">
      <template #authorized-content>
        <q-card flat bordered>
          <div class="q-pa-md">
            <q-radio
              keep-color
              dense
              color="teal"
              v-model="emaOrBB"
              val="ema"
              :label="'EMA'"
            >
              <q-tooltip>Exponential Moving Average</q-tooltip>
            </q-radio>
            <q-radio
              class="q-ml-md"
              keep-color
              dense
              color="teal"
              v-model="emaOrBB"
              val="bb"
              :label="'BB'"
            >
              <q-tooltip>Bollinger Band</q-tooltip>
            </q-radio>
          </div>
          <div class="text-center q-pa-sm q-gutter-sm row">
            <q-select
              class="col-md-3 col-xs-12"
              v-model="buttonBuyOrSell"
              dense
              :hint="'Signal Type'"
              label="buy/sell"
              outlined
              :options="['buy', 'sell']"
            ></q-select>
          </div>
          <div class="row justify-cente q-pb-sm">
            <div class="justify-left q-gutter-sm">
              <q-radio
                v-model="timePeriod"
                val="hourly"
                label="Hourly"
                color="red"
                keep-color
              />
              <q-radio
                v-model="timePeriod"
                val="daily"
                label="Daily"
                color="cyan"
                keep-color
              />
              <q-radio
                v-model="timePeriod"
                val="weekly"
                label="Weekly"
                color="cyan"
                keep-color
              />
            </div>
          </div>
          <q-tabs
            v-model="tab"
            dense
            inweak-label
            outside-arrows
            mobile-arrows
            :class="$q.dark.mode ? 'bg-grey-10' : 'text-grey-9 bg-grey-4'"
            active-color="white"
            :active-bg-color="$q.dark.mode ? 'grey-9' : 'blue-4'"
            :indicator-color="$q.dark.mode ? 'grey-7' : 'blue-5'"
            align="justify"
            narrow-indicator
          >
            <q-tab
              name="meanReversalBucket"
              label="Mean Reversal Bucket"
              no-caps
            />
            <q-tab
              name="meanReversalAlert"
              label="Mean Reversal Alert With Price Action"
              no-caps
            />
            <q-tab
              name="meanReversalSignal"
              label="Mean Reversal Signal "
              no-caps
            />
          </q-tabs>
          <q-separator></q-separator>
          <q-tab-panels class="q-mt-xs" v-model="tab" animated>
            <q-tab-panel class="q-pa-xs" name="meanReversalBucket">
              <div v-if="emaOrBB == 'ema'">
                <ListCardTableViewTradingView
                  :isStatusValid="false"
                  :indicators="['ema']"
                  :tableTitle="'Ema Mean Reversion Bucket Status'"
                  :timePeriod="timePeriod"
                  :buttonBuyOrSell="buttonBuyOrSell"
                  :buyData="emaMeanReversalBoucketDataComputed"
                  :sellData="emaMeanReversalSellBoucketDataComputed"
                  :alertOrSignal="'alert'"
                  @selectedSymbol="(s) => (selectedSymbol = s)"
                />
              </div>
              <div v-if="emaOrBB == 'bb'">
                <ListCardTableViewTradingView
                  :isStatusValid="false"
                  :indicators="['bb']"
                  :tableTitle="'BB Mean Reversion Bucket Status'"
                  :buttonBuyOrSell="buttonBuyOrSell"
                  :buyData="BBBuyListDataComputed"
                  :sellData="BBSellListDataComputed"
                  :alertOrSignal="'alert'"
                  @selectedSymbol="(s) => (selectedSymbol = s)"
                />
              </div>
            </q-tab-panel>
            <q-tab-panel class="q-pa-xs" name="meanReversalAlert">
              <div v-if="emaOrBB == 'ema'">
                <ListCardTableViewTradingView
                  :tableTitle="'Ema Mean Reversion Alert Status'"
                  :indicators="['ema']"
                  :timePeriod="timePeriod"
                  :buttonBuyOrSell="buttonBuyOrSell"
                  :buyData="emaMeanReversalAlertDataComputed"
                  :sellData="emaMeanReversalSellAlertDataComputed"
                  :alertOrSignal="'alert'"
                  @selectedSymbol="(s) => (selectedSymbol = s)"
                />
              </div>
              <div v-if="emaOrBB == 'bb'">
                <ListCardTableViewTradingView
                  :tableTitle="'BB Mean Reversion Alert Status'"
                  :indicators="['bb']"
                  :buttonBuyOrSell="buttonBuyOrSell"
                  :buyData="bBMeanReversalAlertDataComputed"
                  :sellData="bBmeanReversalSellAlertDataComputed"
                  :alertOrSignal="'alert'"
                  @selectedSymbol="(s) => (selectedSymbol = s)"
                />
              </div>
            </q-tab-panel>
            <q-tab-panel class="q-pa-xs" name="meanReversalSignal">
              <div v-if="emaOrBB == 'ema'">
                <ListCardTableViewTradingView
                  :tableTitle="'Ema Mean Reversion Signal Status'"
                  :indicators="['ema']"
                  :buttonBuyOrSell="buttonBuyOrSell"
                  :buyData="emaMeanReversalSignalDataComputed"
                  :sellData="emaMeanReversalSellSignalDataComputed"
                  :alertOrSignal="'signal'"
                  @selectedSymbol="(s) => (selectedSymbol = s)"
                  :isSignalType="true"
                  :signalTypeData="buySellTargertData"
                />
              </div>
              <div v-if="emaOrBB == 'bb'">
                <ListCardTableViewTradingView
                  :tableTitle="'BB Mean Reversion Signal Status'"
                  :indicators="['bb']"
                  :buttonBuyOrSell="buttonBuyOrSell"
                  :buyData="bBMeanReversalSignalDataComputed"
                  :sellData="bBMeanReversalSellSignalDataComputed"
                  :alertOrSignal="'signal'"
                  @selectedSymbol="(s) => (selectedSymbol = s)"
                  :isSignalType="true"
                  :signalTypeData="buySellTargertData"
                />
              </div>
            </q-tab-panel>
          </q-tab-panels>
        </q-card>
      </template>
    </PackageAuth>
  </q-card>
</template>

<script setup>
import { ref, watch, onMounted, computed } from "vue";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
import { useStore } from "vuex";

import useData from "src/use/data";

import ListCardTableViewTradingView from "src/components/TradingSignalsAndType/StockWiseListCardTableViewTradingView.vue";

import PackageAuth from "src/components/Packages/PackageAuth.vue";

const $q = useQuasar();
const $store = useStore();
const $route = useRoute();
const {
  meanReversalAlertHourly,
  meanReversalSellSignalHourly,
  meanReversalSellAlertHourly,
  meanReversalAlertWeekly,
  meanReversalBoucketWeekly,
  meanReversalSellBoucketWeekly,
  meanReversalBoucketHourly,
  meanReversalSellBoucketHourly,
  meanReversalSellAlertWeekly,
  meanReversalSignalWeekly,
  meanReversalSellSignalWeekly,
  meanReversalSignalHourly,
  meanReversalSignal,
  meanReversalAlertSell,
  meanReversalSignalSell,
  meanReversalAlert,
  bBmeanReversalAlert,
  bBmeanReversalSellAlert,
  bBmeanReversalSignal,
  bBmeanReversalSellSignal,
  meanReversalBoucketDaily,
  meanReversalSellBoucketDaily,
  meanReversionBuyList,
  meanReversionSellList,
  BBBuyList,
  BBSellList,
} = useData();

const props = defineProps({
  symbol: {
    type: String,
  },
});

let timePeriod = ref("daily");
timePeriod.value = ref($route.query?.t || "daily")._value;
let emaOrBB = ref("ema");
emaOrBB.value = ref($route.query?.i || "ema")._value;
let buttonBuyOrSell = ref("buy");
buttonBuyOrSell.value = ref($route.query?.s || "buy")._value;

const emaMeanReversalSellSignalData = ref([]);
const emaMeanReversalSellSignalDailyData = ref([]);
const emaMeanReversalSellSignalWeeklyData = ref([]);
const emaMeanReversalSellSignalHourlyData = ref([]);

let tab = ref($route.query?.type || "meanReversalAlert");

const loading = ref(true);
const selectedSymbol = ref(null);

const meanReversionBuyListData = ref([]);
const meanReversionBuyListDailyData = ref([]);
const meanReversionBuyListWeeklyData = ref([]);
const meanReversionBuyListHourlyData = ref([]);

const meanReversionSellListData = ref([]);
const meanReversionSellListDailyData = ref([]);
const meanReversionSellListWeeklyData = ref([]);
const meanReversionSellListHourlyData = ref([]);

const BBBuyListData = ref([]);
const BBBuyListDailyData = ref([]);
const BBBuyListWeeklyData = ref([]);
const BBBuyListHourlyData = ref([]);

const BBSellListData = ref([]);
const BBSellListDailyData = ref([]);
const BBSellListWeeklyData = ref([]);
const BBSellListHourlyData = ref([]);

const emaMeanReversalSignalData = ref([]);
const emaMeanReversalSignalDailyData = ref([]);
const emaMeanReversalSignalWeeklyData = ref([]);
const emaMeanReversalSignalHourlyData = ref([]);

const emaMeanReversalBoucketData = ref([]);
const emaMeanReversalSellBoucketData = ref([]);
const emaMeanReversalAlertData = ref([]);
const emaMeanReversalAlertDailyData = ref([]);
const emaMeanReversalAlertWithPriceActionWeeklyData = ref([]);
const emaMeanReversalBoucketWeeklyData = ref([]);
const emaMeanReversalSellBoucketWeeklyData = ref([]);
const emaMeanReversalBoucketHourlyData = ref([]);
const emaMeanReversalSellBoucketHourlyData = ref([]);
const emaMeanReversalAlertHourlyData = ref([]);
const emaMeanReversalBoucketDailyData = ref([]);
const emaMeanReversalSellBoucketDailyData = ref([]);

const bBMeanReversalAlertData = ref([]);
const bBMeanReversalAlertDailyData = ref([]);
const bBMeanReversalAlertWeeklyData = ref([]);
const bBMeanReversalAlertHourlyData = ref([]);

const bBmeanReversalSellAlertData = ref([]);
const bBmeanReversalSellAlertDailyData = ref([]);
const bBmeanReversalSellAlertWeeklyData = ref([]);
const bBmeanReversalSellAlertHourlyData = ref([]);

const bBMeanReversalSignalData = ref([]);
const bBMeanReversalSignalDailyData = ref([]);
const bBMeanReversalSignalWeeklyData = ref([]);
const bBMeanReversalSignalHourlyData = ref([]);

const bBMeanReversalSellSignalData = ref([]);
const bBMeanReversalSellSignalDailyData = ref([]);
const bBMeanReversalSellSignalWeeklyData = ref([]);
const bBMeanReversalSellSignalHourlyData = ref([]);

const emaMeanReversalSellAlertData = ref([]);
const emaMeanReversalSellAlertDailyData = ref([]);
const emaMeanReversalSellAlertWithPriceActionWeeklyData = ref([]);
const emaMeanReversalSellAlertHourlyData = ref([]);

let dailyDataLoaded = false;
let weeklyDataLoaded = false;
let hourlyDataLoaded = false;

onMounted(() => {
  loadDailyData();
});

watch(timePeriod, (newVal, oldVal) => {
  switch (timePeriod.value) {
    case "daily":
      if (!dailyDataLoaded) {
        loadDailyData();
      } else {
        activeDailyData();
      }
      break;

    case "weekly":
      if (!weeklyDataLoaded) {
        loadWeeklyData();
      } else {
        activeWeeklyData();
      }
      break;
    case "hourly":
      if (!hourlyDataLoaded) {
        loadHourlyData();
      } else {
        activeHourlyData();
      }
  }
});

function activeDailyData() {
  if (timePeriod.value == "daily") {
    meanReversionBuyListData.value = meanReversionBuyListDailyData.value;
    meanReversionSellListData.value = meanReversionSellListDailyData.value;

    BBBuyListData.value = BBBuyListDailyData.value;
    BBSellListData.value = BBSellListDailyData.value;

    bBMeanReversalAlertData.value = bBMeanReversalAlertDailyData.value;
    bBmeanReversalSellAlertData.value = bBmeanReversalSellAlertDailyData.value;

    bBMeanReversalSignalData.value = bBMeanReversalSignalDailyData.value;
    bBMeanReversalSellSignalData.value =
      bBMeanReversalSellSignalDailyData.value;

    emaMeanReversalSignalData.value = emaMeanReversalSignalDailyData.value;
    emaMeanReversalAlertData.value = emaMeanReversalAlertDailyData.value;

    emaMeanReversalSellSignalData.value =
      emaMeanReversalSellSignalDailyData.value;
    emaMeanReversalSellAlertData.value =
      emaMeanReversalSellAlertDailyData.value;

    emaMeanReversalBoucketData.value = emaMeanReversalBoucketDailyData.value;
    emaMeanReversalSellBoucketData.value =
      emaMeanReversalSellBoucketDailyData.value;
  }
}

function activeWeeklyData() {
  if (timePeriod.value == "weekly") {
    meanReversionBuyListData.value = meanReversionBuyListWeeklyData.value;
    meanReversionSellListData.value = meanReversionSellListWeeklyData.value;

    BBBuyListData.value = BBBuyListWeeklyData.value;
    BBSellListData.value = BBSellListWeeklyData.value;

    bBMeanReversalAlertData.value = bBMeanReversalAlertWeeklyData.value;
    bBmeanReversalSellAlertData.value = bBmeanReversalSellAlertWeeklyData.value;

    bBMeanReversalSignalData.value = bBMeanReversalSignalWeeklyData.value;
    bBMeanReversalSellSignalData.value =
      bBMeanReversalSellSignalWeeklyData.value;

    emaMeanReversalSignalData.value = emaMeanReversalSignalWeeklyData.value;
    emaMeanReversalSellSignalData.value =
      emaMeanReversalSellSignalWeeklyData.value;

    emaMeanReversalAlertData.value =
      emaMeanReversalAlertWithPriceActionWeeklyData.value;
    emaMeanReversalSellAlertData.value =
      emaMeanReversalSellAlertWithPriceActionWeeklyData.value;

    emaMeanReversalBoucketData.value = emaMeanReversalBoucketWeeklyData.value;
    emaMeanReversalSellBoucketData.value =
      emaMeanReversalSellBoucketWeeklyData.value;
  }
}

function activeHourlyData() {
  if (timePeriod.value == "hourly") {
    meanReversionBuyListData.value = meanReversionBuyListHourlyData.value;
    meanReversionSellListData.value = meanReversionSellListHourlyData.value;

    BBBuyListData.value = BBBuyListHourlyData.value;
    BBSellListData.value = BBSellListHourlyData.value;

    bBMeanReversalAlertData.value = bBMeanReversalAlertHourlyData.value;
    bBmeanReversalSellAlertData.value = bBmeanReversalSellAlertHourlyData.value;

    bBMeanReversalSignalData.value = bBMeanReversalSignalHourlyData.value;
    bBMeanReversalSellSignalData.value =
      bBMeanReversalSellSignalHourlyData.value;

    emaMeanReversalAlertData.value = emaMeanReversalAlertHourlyData.value;
    emaMeanReversalSellAlertData.value =
      emaMeanReversalSellAlertHourlyData.value;

    emaMeanReversalSignalData.value = emaMeanReversalSignalHourlyData.value;
    emaMeanReversalSellSignalData.value =
      emaMeanReversalSellSignalHourlyData.value;

    emaMeanReversalBoucketData.value = emaMeanReversalBoucketHourlyData.value;

    emaMeanReversalSellBoucketData.value =
      emaMeanReversalSellBoucketHourlyData.value;
  }
}

function loadDailyData() {
  dailyDataLoaded = true;
  meanReversionBuyList(365)
    .then((res) => {
      meanReversionBuyListDailyData.value = res.data;
      activeDailyData();
    })
    .catch((error) => {
      console.log(error);
    });

  meanReversionSellList(365)
    .then((res) => {
      meanReversionSellListDailyData.value = res.data;
      activeDailyData();
    })
    .catch((error) => {
      console.log(error);
    });

  meanReversalSignal(365)
    .then((res) => {
      emaMeanReversalSignalDailyData.value = res.data;
      activeDailyData();
      loading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });

  meanReversalAlert(365)
    .then((res) => {
      emaMeanReversalAlertDailyData.value = res.data;
      activeDailyData();
      loading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });

  meanReversalSignalSell(365)
    .then((res) => {
      emaMeanReversalSellSignalDailyData.value = res.data;
      activeDailyData();
      loading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });

  meanReversalAlertSell(365)
    .then((res) => {
      emaMeanReversalSellAlertDailyData.value = res.data;
      activeDailyData();
      loading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });

  BBBuyList(365)
    .then((res) => {
      BBBuyListDailyData.value = res.data;
      activeDailyData();
    })
    .catch((error) => {
      console.log(error);
    });

  BBSellList(365)
    .then((res) => {
      BBSellListDailyData.value = res.data;
      activeDailyData();
    })
    .catch((error) => {
      console.log(error);
    });

  bBmeanReversalAlert(365)
    .then((res) => {
      bBMeanReversalAlertDailyData.value = res.data;
      activeDailyData();
      loading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });

  bBmeanReversalSellAlert(365)
    .then((res) => {
      bBmeanReversalSellAlertDailyData.value = res.data;
      activeDailyData();
      loading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });

  bBmeanReversalSignal(365)
    .then((res) => {
      bBMeanReversalSignalDailyData.value = res.data;
      activeDailyData();
      loading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });

  bBmeanReversalSellSignal(365)
    .then((res) => {
      bBMeanReversalSellSignalDailyData.value = res.data;
      activeDailyData();
      loading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });
  meanReversalBoucketDaily(365)
    .then((res) => {
      emaMeanReversalBoucketDailyData.value = res.data;
      activeDailyData();
      loading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });
  meanReversalSellBoucketDaily(365)
    .then((res) => {
      emaMeanReversalSellBoucketDailyData.value = res.data;
      activeWeeklyData();
      loading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });
}

function loadHourlyData() {
  hourlyDataLoaded = true;
  meanReversalSignalHourly(365)
    .then((res) => {
      emaMeanReversalSignalHourlyData.value = res.data;
      activeHourlyData();
      loading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });

  meanReversalAlertHourly(365)
    .then((res) => {
      emaMeanReversalAlertHourlyData.value = res.data;
      activeHourlyData();
      loading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });
  meanReversalSellSignalHourly(365)
    .then((res) => {
      emaMeanReversalSellSignalHourlyData.value = res.data;
      activeHourlyData();
      loading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });

  meanReversalSellAlertHourly(365)
    .then((res) => {
      activeHourlyData();
      loading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });
  meanReversalBoucketHourly(365)
    .then((res) => {
      emaMeanReversalBoucketHourlyData.value = res.data;
      activeHourlyData();
      loading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });
  meanReversalSellBoucketHourly(365)
    .then((res) => {
      emaMeanReversalSellBoucketHourlyData.value = res.data;
      activeHourlyData();
      loading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });
}

function loadWeeklyData() {
  weeklyDataLoaded = true;
  meanReversalSignalWeekly(365)
    .then((res) => {
      emaMeanReversalSignalWeeklyData.value = res.data;
      activeWeeklyData();
      loading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });

  meanReversalAlertWeekly(365)
    .then((res) => {
      emaMeanReversalAlertWithPriceActionWeeklyData.value = res.data;
      activeWeeklyData();
      loading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });

  meanReversalBoucketWeekly(365)
    .then((res) => {
      emaMeanReversalBoucketWeeklyData.value = res.data;
      activeWeeklyData();
      loading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });
  meanReversalSellBoucketWeekly(365)
    .then((res) => {
      emaMeanReversalSellBoucketWeeklyData.value = res.data;
      activeWeeklyData();
      loading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });
  meanReversalSellSignalWeekly(365)
    .then((res) => {
      emaMeanReversalSellSignalWeeklyData.value = res.data;
      activeWeeklyData();
      loading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });

  meanReversalSellAlertWeekly(365)
    .then((res) => {
      emaMeanReversalSellAlertWithPriceActionWeeklyData.value = res.data;
      activeWeeklyData();
      loading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });
}

const createFilteredComputed = (dataRef) => {
  return computed(() =>
    dataRef.value.filter((item) => item.symbol === props.symbol)
  );
};

// Optimized computed properties
const emaMeanReversalBoucketDataComputed = createFilteredComputed(
  emaMeanReversalBoucketData
);
const emaMeanReversalSellBoucketDataComputed = createFilteredComputed(
  emaMeanReversalSellBoucketData
);
const BBBuyListDataComputed = createFilteredComputed(BBBuyListData);
const BBSellListDataComputed = createFilteredComputed(BBSellListData);

const emaMeanReversalAlertDataComputed = createFilteredComputed(
  emaMeanReversalAlertData
);
const emaMeanReversalSellAlertDataComputed = createFilteredComputed(
  emaMeanReversalSellAlertData
);
const bBMeanReversalAlertDataComputed = createFilteredComputed(
  bBMeanReversalAlertData
);
const bBmeanReversalSellAlertDataComputed = createFilteredComputed(
  bBmeanReversalSellAlertData
);

const emaMeanReversalSignalDataComputed = createFilteredComputed(
  emaMeanReversalSignalData
);
const emaMeanReversalSellSignalDataComputed = createFilteredComputed(
  emaMeanReversalSellSignalData
);
const bBMeanReversalSignalDataComputed = createFilteredComputed(
  bBMeanReversalSignalData
);
const bBMeanReversalSellSignalDataComputed = createFilteredComputed(
  bBMeanReversalSellSignalData
);
</script>
